import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAgreements } from '@/api';
import type { AgreementItem } from '@/api';

export default function AgreementsPage() {
  const navigate = useNavigate();
  const [agreements, setAgreements] = useState<AgreementItem[]>([]);
  const [activeId, setActiveId] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getAgreements()
      .then((res) => {
        setAgreements(res || []);
        //默认选中第一个协议
        if (res && res.length > 0) setActiveId(res[0].id);
        setError('');
      })
      .catch((err) => {
        setError(err instanceof Error ? err.message : '加载失败');
      })
      .finally(() => setLoading(false));
  }, []);

  const active = agreements.find((a) => a.id === activeId) || null;

  return (
    <div className="mobile-container bg-background-50 min-h-screen pb-10">
      {/* Header */}
      <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-background-200/50">
        <div className="flex items-center px-4 h-12">
          <button
            onClick={() => navigate(-1)}
            className="w-9 h-9 rounded-lg flex items-center justify-center text-foreground-700 cursor-pointer hover:bg-background-100 active:scale-95 transition-all"
            aria-label="返回"
          >
            <i className="ri-arrow-left-line text-xl" />
          </button>
          <h1 className="flex-1 text-center text-foreground-950 text-base font-bold tracking-wide">
            签约中心
          </h1>
          <div className="w-9" />
        </div>
      </header>

      {loading ? (
        <div className="flex flex-col items-center justify-center py-24">
          <i className="ri-loader-4-line text-primary-400 text-3xl animate-spin mb-3" />
          <p className="text-foreground-400 text-sm">加载中...</p>
        </div>
      ) : error ? (
        <div className="flex flex-col items-center justify-center py-24">
          <i className="ri-wifi-off-line text-foreground-300 text-3xl mb-3 block" />
          <p className="text-foreground-400 text-sm">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-6 py-2 rounded-full bg-primary-500 text-white text-xs font-bold cursor-pointer"
          >
            重新加载
          </button>
        </div>
      ) : agreements.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-24">
          <div className="w-16 h-16 rounded-2xl bg-background-100 flex items-center justify-center mx-auto mb-4">
            <i className="ri-file-list-3-line text-foreground-300 text-2xl" />
          </div>
          <p className="text-foreground-400 text-sm font-medium">暂无协议</p>
          <p className="text-foreground-300 text-xs mt-1">平台协议会在这里展示</p>
        </div>
      ) : (
        <>
          {/* 协议 tab（胶囊式分段选择，横向可滑动） */}
          <div className="sticky top-12 z-30 bg-background-50/90 backdrop-blur-md">
            <div className="px-4 pt-3 pb-3">
              <div className="flex gap-2 overflow-x-auto scrollbar-hide py-1">
                {agreements.map((item) => {
                  const active = activeId === item.id;
                  return (
                    <button
                      key={item.id}
                      onClick={() => setActiveId(item.id)}
                      className={`flex-shrink-0 h-9 px-5 rounded-full text-sm cursor-pointer transition-all duration-200 active:scale-95 flex items-center gap-1.5 ${
                        active
                          ? 'bg-gradient-to-r from-primary-500 to-primary-600 text-white font-bold shadow-md shadow-primary-500/30'
                          : 'bg-white text-foreground-500 border border-background-200/70 hover:border-primary-200 hover:text-primary-500'
                      }`}
                    >
                      {active && <i className="ri-check-line text-base leading-none" />}
                      {item.name || '未命名协议'}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>

          {/* 协议内容（富文本） */}
          <main className="px-4 py-4">
            {active && active.content ? (
              <div
                className="rich-content bg-white rounded-2xl px-4 py-4 text-foreground-600 text-sm leading-relaxed break-words"
                dangerouslySetInnerHTML={{ __html: active.content }}
              />
            ) : (
              <div className="bg-white rounded-2xl px-4 py-10 text-center">
                <p className="text-foreground-300 text-sm">该协议暂无内容</p>
              </div>
            )}
          </main>
        </>
      )}
    </div>
  );
}
